import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, NgZone, OnChanges, SimpleChanges, DoCheck, ApplicationRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Configuration } from './app.constants';

import { OidcSecurityService } from './auth/services/oidc.security.service';
import { AuthWellKnownEndpoints } from './auth/services/auth.well-known-endpoints';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { SheetService } from './shared/sheet-export-import/sheet.service';
import { NotificationHandlerService } from './shared/notifications/notification-handler.service';
import { LoadingService, AuthorizedStatusService } from './index';
import { ReportUnitBackgroundService, ReportCancelledUnitBackgroundService } from './tools/index';

import './app.component.css';
import { PreloaderHandler, BLUE_FULL, BLUE_FULL_LARGE } from './shared/preloader/preloader-handler';
import { AuthUpdateModel } from './shared/models/AuthUpdateModel';
declare var $: any;

@Component({
    selector: 'my-app',
    providers: [
        SheetService,
        LoadingService,
        ReportUnitBackgroundService,
        ReportCancelledUnitBackgroundService,
        AuthorizedStatusService
    ],
    templateUrl: 'app.component.html'
})

export class AppComponent implements OnInit, OnDestroy {

    currentYear = new Date().getFullYear();
    isAuthorizedSubscription: Subscription;
    isAuthorized = false;
    authUpdate: AuthUpdateModel = { authStatus: false, msg: '' };
    wellKnownEndpointsLoaded = false;
    moduleIsSetup = false;
    private uData: any;
    private preloaderHandler: PreloaderHandler;

    constructor(private _sheetService: SheetService, private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService, public wellKnownEndpoints: AuthWellKnownEndpoints, private zone: NgZone, private ref: ChangeDetectorRef) {
        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, BLUE_FULL_LARGE);
        this.preloaderHandler.reset('Loading', 0.6);

        this.oidcSecurityService.getIsAuthorized().subscribe(
            (isAuthorized: any) => {
                //console.log('IsAuth: ' + isAuthorized);
                this.isAuthorized = isAuthorized;
            });

        if (this.oidcSecurityService.moduleSetup) {
            this.doCallbackLogicIfRequired();
        } else {
            this.oidcSecurityService.onModuleSetup.subscribe(() => {
                this.doCallbackLogicIfRequired();
            });
        }
    }

    ngOnInit() {
        this.oidcSecurityService.getUserData().subscribe(data => this.uData = data);
    }

    ngOnDestroy(): void {
        this.isAuthorizedSubscription.unsubscribe();
        this.oidcSecurityService.onModuleSetup.unsubscribe();
    }

    login() {
        this.oidcSecurityService.authorize();
    }

    refreshSession() {
        this.oidcSecurityService.authorize();
    }

    logout() {
        this.closeSideNav();
        this.oidcSecurityService.logoff();
    }

    public getAuthorized(): boolean {
        return this.oidcSecurityService._isAuthorizedValue;
    }

    private getCompany(): string {
        return (this.uData.company == null ? '' : this.uData.company);
    }

    private getUsername(): string {
        return (this.uData.fullName == null ? '' : this.uData.fullName);
    }

    private closeSideNav(): void {
        $('.button-collapse').sideNav('hide');
    }

    private doCallbackLogicIfRequired() {
        if (window.location.hash) {
            //console.log('***********WINDOW HAS HASH***************');
            if (this.oidcSecurityService.authWellKnownEndpointsLoaded) {
                this.oidcSecurityService.authorizedCallback();
            } else {
                this.oidcSecurityService.onEnpointsLoaded.subscribe(() => {
                    this.oidcSecurityService.authorizedCallback();
                });
            }
        } else {
            if (!this.wellKnownEndpoints.endPointsLoaded) {
                this.wellKnownEndpoints.onWellKnownEndpointsLoaded.subscribe(() => {
                    this.login();
                });
            } else {
                this.login();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./angularApp/app/app.component.ts